<template>
  <div>
    <p class="decode-result">Last result: <b>{{ result }}</b></p>

    <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
      <div v-show="cameraForzen" class="validation-layer">
        <div class="validation-notice" v-if="validating">
          {{ $t('qrcode_progress') }}
        </div>

        <div class="validation-result" v-if="!validating">
          <div v-if="isValid" class="valid">
            {{ $t('qrcode_valid') }}
          </div>

          <div v-else class="invalid">
            {{ $t('qrcode_valid') }}
          </div>
        </div>
      </div>
    </qrcode-stream>
  </div>
</template>

<script>
	export default {
		methods: {
      async onDecode (content) {
        this.result = content

        this.stopCamera()

        this.validating = true
        this.isValid = await this.validate(content)
        this.validating = false

        window.setTimeout(() => {
          this.startCamera()
        }, 2000)
      },
      // validate (content) {
      //   return firestore
      //   .collection("clients")
      //   .where("clientid", "==", content)
      //   .get()
      //   .then(snapshot => {
      //     return new Promise(resolve => {
            
      //           if (!snapshot.empty) {return resolve(true)}
      //           else{return resolve(false)}
            
      //     });
      //   });
      // },
      async onInit (promise) {
        this.loading = true

        try {
          await promise
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
        } finally {
          this.firstLoad = false
          this.loading = false
        }
      }
		},
    
	}
</script>